import { render, staticRenderFns } from "./home-ia.vue?vue&type=template&id=7609cdc6&"
import script from "./home-ia.vue?vue&type=script&lang=js&"
export * from "./home-ia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7609cdc6')) {
      api.createRecord('7609cdc6', component.options)
    } else {
      api.reload('7609cdc6', component.options)
    }
    module.hot.accept("./home-ia.vue?vue&type=template&id=7609cdc6&", function () {
      api.rerender('7609cdc6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/home-ia.vue"
export default component.exports